<template >
  <nav v-if="statoToken !=''" class="topnav navbar navbar-expand shadow justify-content-between justify-content-sm-start navbar-light bg-white" id="sidenavAccordion">
        <!-- Sidenav Toggle Button-->
        <!-- <button class="btn btn-icon btn-transparent-dark order-1 order-lg-0 me-2 ms-lg-2 me-lg-0" id="sidebarToggle"><i data-feather="menu"></i></button> -->
        <!-- Navbar Brand-->
        <!-- * * Tip * * You can use text or an image for your navbar brand.-->
        <!-- * * * * * * When using an image, we recommend the SVG format.-->
        <!-- * * * * * * Dimensions: Maximum height: 32px, maximum width: 240px-->
        <img src="img/poligeo.png" style="height:32px;"/>

        <router-link to="/dashboard" class="navbar-brand pe-3 ps-4 ps-lg-2">Studio Poligeo - Gestione documenti</router-link>
        
        
        <!-- Navbar Search Input-->
        <!-- * * Note: * * Visible only on and above the lg breakpoint-->

        <!-- <form class="form-inline me-auto d-none d-lg-block me-3">
            <div class="input-group input-group-joined input-group-solid">
                <input class="form-control pe-0" type="search" placeholder="Search" aria-label="Search" />
                <div class="input-group-text"><i data-feather="search"></i></div>
            </div>
        </form> -->
        <!-- Navbar Items-->
        <ul class="navbar-nav align-items-center ms-auto">
            <li class="nav-item no-caret dropdown-user me-3 px-5">
                <messaggio-globale></messaggio-globale>
                
            </li>
            <!-- User Dropdown-->
            <li class="nav-item dropdown no-caret dropdown-user me-3 me-lg-4">
                <a class="btn btn-icon btn-transparent-dark dropdown-toggle" id="navbarDropdownUserImage" href="javascript:void(0);" role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><img class="img-fluid" src="tema/assets/img/illustrations/profiles/profile-1.png" /></a>
                <div class="dropdown-menu dropdown-menu-end border-0 shadow animated--fade-in-up" aria-labelledby="navbarDropdownUserImage">
                    <h6 class="dropdown-header d-flex align-items-center">
                        <img class="dropdown-user-img" src="tema/assets/img/illustrations/profiles/profile-1.png" />
                        <div class="dropdown-user-details">
                            <div class="dropdown-user-details-name">{{this.$store.state.UserInfo.ute_cognome}} {{this.$store.state.UserInfo.ute_nome}}</div>
                            <div class="dropdown-user-details-email">{{this.$store.state.UserInfo.ute_email}}</div>
                        </div>
                    </h6>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item" href="#!" v-if="$store.state.UserInfo.ute_permettiCambioPassword" @click="CambiaPassword">
                        <div class="dropdown-item-icon"><i data-feather="settings"></i></div>
                        Cambia password
                    </a>
                    <a class="dropdown-item" href="#!" @click="DoLogout">
                        <div class="dropdown-item-icon"><i data-feather="log-out"></i></div>
                        Logout
                    </a>
                </div>
            </li>
        </ul>

    </nav>
    <br />
</template>

<script>
import MessaggioGlobale from '@/components/MessaggioGlobale.vue';

export default {
    name: "NavbarTop",
    components: { MessaggioGlobale },
    inject: ['cfg'],
    props: { 
       
    },
    data: function() {
        return {

            mostraMessaggio: false,
            alertMessaggio: "",
            alertClass: "",     
            alertIcon: "",
            alertIconSpin: false  
        
        }
    },
    methods: {
        CambiaPassword() {
            if(confirm("Per procedere al cambio password è necessario disconnettersi ed effettuare nuovamente al login. Continuare?")) {

                this.$store.commit('Messaggio', {parms: [true, ['Logout in corso...'], 'alert alert-info', 'fa-spinner', true, 0]});

                fetch(this.cfg.apisrv + "/api/User/DoLogout?token=" + this.$store.state.UserInfo.token + "&resetPwd=true" )
                .then(response => response.json())
                .then(obj => {
                    this.$store.commit('Messaggio', {parms: [true, ['Fatto.'], 'alert alert-success', 'fa-check', true, 1000]});

                    this.$store.commit('UserInfo',{ token: "" });
                    this.$router.push("/");  
                });

            }
        },
        DoLogout() {

            this.$store.commit('Messaggio', {parms: [true, ['Logout in corso...'], 'alert alert-info', 'fa-spinner', true, 0]});

            fetch(this.cfg.apisrv + "/api/User/DoLogout?token=" + this.$store.state.UserInfo.token + "&resetPwd=false" )
            .then(response => response.json())
            .then(obj => {
                this.$store.commit('Messaggio', {parms: [true, ['Fatto.'], 'alert alert-success', 'fa-check', true, 1000]});

                this.$store.commit('UserInfo',{ token: "" });
                this.$router.push("/");  
            });

            
        },
    },
    computed: {
        statoToken() {
            return this.$store.state.UserInfo.token;
        }
    },
    mounted: function() {
        //if(this.$store.state.UserInfo.token == "") { this.mostraNavbar = false; }
        //else { this.mostraNavbar = true; }
    }
}
</script>

<style>

</style>